var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoRegistro3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icono-registro-3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono-registro-3",
    clipPath: "url(#clip-icono-registro-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_crop_landscape_24px",
    d: "M25,2H5A2.006,2.006,0,0,0,3,4V17a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,25,2Zm0,15H5V4H25Z",
    transform: "translate(30 10) rotate(90)",
    fill: "#225b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_crop_landscape_24px-2",
    "data-name": "ic_crop_landscape_24px",
    d: "M10,2H5A2.006,2.006,0,0,0,3,4V17a2.006,2.006,0,0,0,2,2h5a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,10,2Zm0,15H5V4h5Z",
    transform: "translate(30 10) rotate(90)",
    fill: "#225b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_wb_incandescent_24px",
    d: "M3.866,23.691,6,25.829,9.718,22.1,7.581,19.961,3.866,23.691Zm12.3,4.929h3.032V22.146H16.162ZM6.549,10.5H1v3.032H6.549Zm22.26,0v3.032h5.549V10.5ZM25.624,22.114l3.714,3.729,2.138-2.138-3.729-3.714-2.123,2.123Z",
    transform: "translate(37.179 31.619) rotate(180)",
    fill: "#225b2a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRegistro3);
export default __webpack_public_path__ + "static/media/icono-registro-3.c095d22e8d4bf4f024e7c540293b00e2.svg";
export { ForwardRef as ReactComponent };